import Layout from 'components/Layout';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const FilesRoutes = () => {
  return (
    <Layout>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.RECAPTCHA_SITE_KEY ?? ''}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogWriter" element={<Home />} />
          {/* <Route path="/socialMedia" element={<Home />} /> */}
          <Route path="/textToImage" element={<Home />} />
          <Route path="/textToLogo" element={<Home />} />
          <Route path="/gifMaker" element={<Home />} />
          <Route path="/imageEditor" element={<Home />} />
        </Routes>
      </GoogleReCaptchaProvider>
    </Layout>
  );
};

export default FilesRoutes;
